export default function ProfileSkeleton() {
  return (
    <div className="w-full mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-6 animate-pulse">
      {/* Header */}
      <div className="mb-6 space-y-2">
        <div className="h-6 w-32 bg-gray-200 rounded" />
        <div className="h-4 w-72 bg-gray-200 rounded" />
      </div>

      <div className="rounded-lg border border-gray-200 bg-white">
        {/* Top bar */}
        <div className="p-5 border-b border-gray-200 flex items-center gap-4">
          <div className="w-14 h-14 rounded-full bg-gray-300" />

          <div className="space-y-2">
            <div className="h-4 w-40 bg-gray-200 rounded" />
            <div className="h-4 w-28 bg-gray-200 rounded" />
            <div className="h-3 w-24 bg-gray-200 rounded" />
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
            {/* Photo */}
            <div className="lg:col-span-5 space-y-3">
              <div className="h-4 w-32 bg-gray-200 rounded" />
              <div className="h-32 rounded-xl bg-gray-200" />
              <div className="flex justify-between">
                <div className="h-3 w-32 bg-gray-200 rounded" />
                <div className="h-9 w-24 bg-gray-300 rounded-lg" />
              </div>
            </div>

            {/* Basic Info */}
            <div className="lg:col-span-7 space-y-4">
              <div className="h-4 w-40 bg-gray-200 rounded" />

              <div className="rounded-lg border border-gray-200 p-4 space-y-3">
                <div className="h-4 w-20 bg-gray-200 rounded" />
                <div className="h-10 bg-gray-200 rounded-lg" />
                <div className="h-3 w-64 bg-gray-200 rounded" />

                <div className="mt-4 flex justify-between items-center border border-gray-200 rounded-lg p-3">
                  <div className="h-3 w-56 bg-gray-200 rounded" />
                  <div className="h-9 w-24 bg-gray-300 rounded-lg" />
                </div>
              </div>
            </div>
          </div>

          {/* Change Password */}
          <div className="mt-8 space-y-4">
            <div className="h-4 w-40 bg-gray-200 rounded" />

            <div className="border border-gray-200 rounded-lg p-5 space-y-4">
              <div className="h-10 bg-gray-200 rounded-lg" />
              <div className="h-10 bg-gray-200 rounded-lg" />
              <div className="h-10 bg-gray-200 rounded-lg" />

              <div className="flex justify-end">
                <div className="h-9 w-36 bg-gray-300 rounded-lg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
